import { h as __h } from "preact";
import { Component } from "preact";
import html from "~/util/html.js";
/** @import { connectionResponse } from "~/backend/validate"; */

import Icon from "~/component/Icon.js";
import Time, { duration } from "~/component/Time.js";
import Tooltip from "~/component/Tooltip.js";
/** @import { TriggerProps } from "~/component/Tooltip.js"; */

import util from "~/style/util.js";
import { adopt, CSS_MODULE_SCRIPTS, importCss } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./StatusChip.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./StatusChip.module.css", import.meta.url);
export const css = adopt(sheet);

/**
 * @extends {Component<StatusChipProps>}
 *
 * @typedef {object} StatusChipProps
 * @property {boolean} online
 * @property {connectionResponse[]} [connections]
 */
export class StatusChip extends Component {
  get connections() {
    return this.props.connections?.filter(c => !c.disconnected_at);
  }

  /** @param {Partial<TriggerProps>} [trigger] */
  renderChip = trigger => {
    const connections = this.connections;
    return __h("div", {
      ...trigger,
      "class": css.chip + " " + css.status + " " + util.liftClicks,
      "data-online": this.props.online
    }, this.props.online ? "Online" : "Offline", connections?.length ? ` (${connections.length})` : "");
  };
  render() {
    const connections = this.connections;
    if (!connections) return this.renderChip();
    return __h(Tooltip, {
      placement: "top",
      disabled: connections.length === 0,
      contents: __h("ul", {
        "class": css.connections
      }, connections.map(conn => __h("li", {
        "class": css.connection
      }, conn.user?.name, conn.control_type === "mcp" && __h(Icon, {
        name: "robot",
        size: 12,
        label: "Agent"
      }), "(", __h(Time, {
        tick: true,
        fmt: duration,
        datetime: new Date(conn.connected_at ?? conn.created_at)
      }), ")")))
    }, this.renderChip);
  }
}
export function MaintenanceChip() {
  return __h(Tooltip, {
    contents: ["This relay is in ", __h("strong", {}, "maintenance mode"), ". New connections will not be accepted."]
  }, (/** @type {TriggerProps} */trigger) => __h("span", {
    ...trigger,
    "class": css.chip + " " + css.maintenance + " " + util.liftClicks
  }, __h(Icon, {
    name: "traffic-cone",
    size: 14,
    label: "Maintenance mode"
  })));
}